import { CSV_URL } from "../../directory/csv/url";
import { loadDirectoryCSV } from "../../directory/csv/loadDirectoryCSV";
import { listGroups } from "./listGroups";
import { initialHTML } from "./intialHTML";
// import { scrapeDirectoryHTML } from "../../directory/scrape/scrapeDirectoryHTML";
initialHTML();
// scrapeDirectoryHTML().then(listGroups);
loadDirectoryCSV(CSV_URL).then(({ deacons }) => listGroups(deacons));
